import MigrationListPage from "./MigrationListPage";
export default function MigrationCallingPage() {
  return <MigrationListPage stage="for_calling_scheduling" title="For Calling/Scheduling" />;
}
